// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { eyeDash16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-eye-dash': IconEyeDash;
    }
}

/**
 * The icon component for the 'eyeDash' icon
 */
export class IconEyeDash extends Icon {
    public constructor() {
        super(eyeDash16X16);
    }
}

registerIcon('icon-eye-dash', IconEyeDash);
export const iconEyeDashTag = 'nimble-icon-eye-dash';
